import get from "lodash/get";
import { createSelector } from "reselect";
import { paths } from "utils/constants";
import { isWebview } from "utils/localStorage";
import { orderRefSelector } from "./order";

export const jumioDomain = state => get(state, "api.jumio", {});
export const jumioDataDomain = state => get(state, "api.jumio.data", {});
export const jumioDetailsDomain = state =>
  get(state, "api.jumioDetails.data", {});

// ***************************************************************
// ******************** jumio selectors *************************
// ***************************************************************

export const jumioRedirectUrlSelectorOld = createSelector(
  jumioDataDomain,
  orderRefSelector,
  (jumio, orderRef) => {
    const jumioUrl = get(jumio, "redirectUrl", "");
    const appUrl = `${paths.EKYC_VERIFY}?order_ref=${orderRef}`;
    return isWebview() && jumioUrl && orderRef ? appUrl : jumioUrl;
  }
);

const jumioRedirectUrlSelector = createSelector(jumioDataDomain, jumioData =>
  get(jumioData, "redirectUrl", false)
);

export const jumioIsUsedSelector = createSelector(jumioDataDomain, jumioData =>
  get(jumioData, "isUsed", false)
);

export const jumioCanPrefillSelector = createSelector(
  jumioDataDomain,
  jumioData => get(jumioData, "canPrefill", false)
);

export const jumioDataSelector = createSelector(
  jumioDataDomain,
  jumioData => jumioData
);

export const jumioDetailsSelector = createSelector(
  jumioDetailsDomain,
  jumioDetails => jumioDetails
);

// ***************************************************************
// ******************* jumio makeSelect *************************
// ***************************************************************
// export const makeSelectjumio = () => jumioSelector;

export const makeSelectJumioIsUsed = () => jumioIsUsedSelector;

export const makeSelectJumioCanPrefill = () => jumioCanPrefillSelector;

export const makeSelectJumioData = () => jumioDataSelector;

export const makeSelectJumioDetails = () => jumioDetailsSelector;

export const makeSelectJumioRedirectUrl = () => jumioRedirectUrlSelector;
